import React from "react";
import { Avatar, makeStyles } from "@material-ui/core";
import { toImageUrl } from "../../../../../utils/formatHelper";
import Color from "../../../../../styles/Color";
import SwitchIOS from "../../../../components/SwitchIOS";

export const initialTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const initialBannerTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getColumns = () => {
    return [
        {
            title: "Title Thai",
            field: "titleTh",
        },
        {
            title: "Title Eng",
            field: "titleEn",
        },
        {
            title: "Icon",
            field: "iconImage",
            sorting: false,
            render: rowData => <Avatar variant="rounded" alt="serviceIcon" src={toImageUrl(rowData?.iconImage)} />,
        },
        {
            title: "Image",
            field: "image",
            sorting: false,
            render: rowData => <Avatar variant="rounded" alt="serviceImage" src={toImageUrl(rowData?.image)} />,
        },
    ];
};

export const getBannerColumns = params => {
    return [
        {
            title: "Start Date",
            field: "startDate",
        },
        {
            title: "End Date",
            field: "endDate",
        },
        {
            title: "Image",
            field: "image",
            sorting: false,
            render: rowData => <Avatar variant="rounded" alt="promotionBannerImage" src={toImageUrl(rowData?.image)} />,
        },
        {
            title: "Status",
            field: "status",
            sorting: false,
            render: rowData => (
                <SwitchIOS
                    color="default"
                    checked={rowData?.status}
                    onChange={() =>
                        params?.handleChangeBannerStatus({
                            checked: !rowData?.status,
                            id: rowData?.marketingServiceBannerId,
                        })
                    }
                    disabled={!params?.thisMenuPermission?.edit}
                />
            ),
        },
    ];
};

export const styles = makeStyles(theme => ({
    tabsContainer: {
        borderBottom: "none",
        "& .nav-item.nav-link": {
            minWidth: 150,
            fontSize: 14,
            justifyContent: "center",
            transition: "all .15s",
            background: "linear-gradient(90deg, rgba(157, 221, 252, 0.25) 0%, rgba(255, 255, 255, 0.25) 100%)",
        },
        "& .nav-item.nav-link:hover": {
            color: Color.primary,
        },
        "& .nav-item.nav-link.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
            fontWeight: 500,
        },
    },
}));
